import { View, Text } from 'react-native';
import React from 'react';

import { serviceDocketInventoryCheckStatus as inventoryStatus } from '../../../../common/utils/vending-settings';
import { shouldMachineBeRestocked } from '../../../../common/utils/serviceRuns/shouldMachineBeRestocked';
import { shouldMachineBeRepaired } from '../../../../common/utils/serviceRuns/shouldMachineBeRepaired';
import { shouldConfirmStockLevels } from '../../../../common/utils/serviceRuns/shouldConfirmStockLevels';
import { countDriverTickets } from '../../../../common/utils/ticketList/countDriverTickets';
import { useUserContext } from '../../../../common/utils/context';
import { getPickListStatusLabel } from '../../../../common/utils/pickList/getPickListStatusLabel';

import { TypographyHeading, Label, Separator } from '../../../components';

const DocketServiceStatusDetail = ({ docket, styles }) => {

	const { machine, inventoryCheck } = docket;
	const { tenantSettings } = useUserContext();

	const isOffline = machine.isOffline ?? !machine.commDevices?.length;
	const supportsStockConfirmation = shouldConfirmStockLevels({
		machineUsesIngredients: machine.usesIngredients,
		isOffline,
	});

	const inventoryConfirmed = inventoryCheck === inventoryStatus.CONFIRMED || inventoryCheck === inventoryStatus.CONFIRMED_WITH_CHANGES;
	const incompletePick = Boolean(!docket.inventoryPicked && (
		docket.inventoryPartiallyPicked || docket.pickList?.isAnyItemPicked
	));
	const pickListStatusLabel = getPickListStatusLabel({
		inventoryPicked: docket.inventoryPicked,
		inventoryPartiallyPicked: docket.inventoryPartiallyPicked,
		isAnyItemPicked: docket.pickList?.isAnyItemPicked,
	});

	const driverTicketCount = docket.ticketList && shouldMachineBeRepaired(docket.machineServiceType) && countDriverTickets(docket.ticketList.driverItems, tenantSettings);

	return (
		<View>
			<Separator style={styles.separator} />
			<Text style={styles.headerText}>Service status</Text>
			{/* <View style={{ flexDirection: 'row', flex: 1, flexWrap: 'wrap' }}> */}
			<View style={{ ...styles.detailView, flexDirection: 'row', flexWrap: 'wrap' }}>
				{
					docket.replacementReviewRequired && (
						<View style={{ marginLeft: 5 }}>
							<TypographyHeading
								subheadingSmallSubtle={true}
								label="Replacement"
							/>
							<Label
								label="Review required"
								red={true}
								style={{ marginLeft: -1, marginTop: 2 }}
							/>
						</View>
					)
				}
				{
					shouldMachineBeRestocked(docket.machineServiceType) && !isOffline && (
						<View style={{ marginLeft: 5 }}>
							<TypographyHeading
								subheadingSmallSubtle={true}
								label="Pick list"
							/>
							<Label
								label={pickListStatusLabel}
								green={docket.inventoryPicked}
								yellow={incompletePick}
								primary={!docket.inventoryPicked && !incompletePick}
								style={{ marginLeft: -1, marginTop: 2 }}
							/>
						</View>
					)
				}
				{
					shouldMachineBeRestocked(docket.machineServiceType) && (
						<View style={{ marginLeft: 5 }}>
							<TypographyHeading
								subheadingSmallSubtle={true}
								label="Restock"
							/>
							<Label
								label={docket.isRestocked ? 'Complete' : 'Pending'}
								green={docket.isRestocked}
								primary={true}
								style={{ marginLeft: -1, marginTop: 2 }}
							/>
						</View>
					)
				}
				{
					supportsStockConfirmation && (
						<View style={{ marginLeft: 5 }}>
							<TypographyHeading
								subheadingSmallSubtle={true}
								label="Stock levels"
							/>
							<Label
								label={inventoryConfirmed ? 'Confirmed' : 'Unconfirmed'}
								primary={!inventoryConfirmed}
								green={inventoryConfirmed}
								style={{ marginLeft: -1, marginTop: 2 }}
							/>
						</View>
					)
				}
				{
					docket.ticketList && shouldMachineBeRepaired(docket.machineServiceType) && driverTicketCount > 0 && (
						<View style={{ marginLeft: 5 }}>
							<TypographyHeading
								subheadingSmallSubtle={true}
								label="Tickets"
							/>
							<Label
								label={docket.ticketsResolved ? 'Resolved' : 'Pending'}
								green={docket.ticketsResolved}
								primary={true}
								style={{ marginLeft: -1, marginTop: 2 }}
							/>
						</View>
					)
				}
				{
					docket.requirePhoto && (
						<View style={{ marginLeft: 5 }}>
							<TypographyHeading
								subheadingSmallSubtle={true}
								label="Photo"
							/>
							<Label
								label={docket.photoTaken ? 'Taken' : 'Pending'}
								green={docket.photoTaken}
								primary={true}
								style={{ marginLeft: -1, marginTop: 2 }}
							/>
						</View>
					)
				}
			</View>
		</View>
	);
};

export default DocketServiceStatusDetail;
